import { defineMessages } from "react-intl";

export const contextualLinks = defineMessages({
  devModePanel: {
    defaultMessage: "Learn more about {apiReference} and view {apiGuide}",
    id: "zRIsjN",
  },
  apiReference: {
    defaultMessage: "API reference",
    id: "Zvo5iu",
  },
  apiGuide: {
    defaultMessage: "API guide",
    id: "BA4leV",
  },
  webhooks: {
    defaultMessage: "Learn more about {extendingSaleor}",
    id: "zT1CvH",
  },
  extendingSaleor: {
    defaultMessage: "extending Saleor with Webhooks",
    id: "B8PvdI",
  },
  staffMembers: {
    defaultMessage: "Learn more about {userPermissions}",
    id: "19o9WS",
  },
  userPermissions: {
    defaultMessage: "User permissions",
    id: "5M+hLZ",
  },
  orders: {
    defaultMessage: "Learn more about {orderManagement}",
    id: "tl1/1E",
  },
  orderManagement: {
    defaultMessage: "order management",
    id: "91vQMc",
  },
  products: {
    defaultMessage: "Learn more about {productConfigurations}",
    id: "C9cgck",
  },
  productConfigurations: {
    defaultMessage: "product configurations",
    id: "dVk241",
  },
  giftCards: {
    defaultMessage: "Learn more about {giftCards}",
    description: "gift cards page subheader",
    id: "sOlOZB",
  },
  giftCardsDocs: {
    description: "gift cards docs link",
    defaultMessage: "gift cards",
    id: "aBpkVh",
  },
  extensions: {
    defaultMessage: "Learn more about {extensions}",
    description: "extensions page subheader",
    id: "yeX6fA",
  },
  extensionsDocs: {
    defaultMessage: "extensions",
    description: "extensions page subheader",
    id: "hVwc73",
  },
  reviews: {
    defaultMessage: "Learn more about {reviewsConfigurations}",
    id: "4AP2wG",
  },
  reviewsConfigurations: {
    defaultMessage: "reviews configurations",
    id: "QocM8+",
  },
});
